
const styles = theme => ({
  root: {
    margin:"0 0 10px 0"
  },
  button: {
    textTransform: "initial",
    fontSize:14,
    height: 40,
    minWidth:150,
    width:"100%",
    color: "#676767",
    backgroundColor: "#fff",
    border: "0px solid #676767",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#676767",
      border: "1px solid transparent"
    }
  },
  moreButton:{
    minWidth:5,
    fontSize:12,
  },
  input: {
    display: 'none',
  },
});


export default styles;